<app-loading></app-loading>
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
<app-global-overlay></app-global-overlay>
